module.exports = __webpack_public_path__ + "img/project6_4.png.cf5afacc.webp";